import { render, staticRenderFns } from "./preview-template.vue?vue&type=template&id=3a3ae8bc&scoped=true"
import script from "./preview-template.vue?vue&type=script&lang=js"
export * from "./preview-template.vue?vue&type=script&lang=js"
import style0 from "./preview-template.vue?vue&type=style&index=0&id=3a3ae8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ae8bc",
  null
  
)

export default component.exports